import { algoliasearch } from "algoliasearch";
import { liteClient } from "algoliasearch/lite";

type BaseConfig = {
	appId: string;
	apiKey: string;
};

type ConfigWithAnalytics = BaseConfig & {
	analyticsKey: string;
};

type ConfigWithoutAnalytics = BaseConfig & {
	analyticsKey?: never;
};

export function createAlgoliaClients(config: ConfigWithAnalytics): {
	client: ReturnType<typeof algoliasearch>;
	searchClient: ReturnType<typeof liteClient>;
	analyticsClient: ReturnType<ReturnType<typeof algoliasearch>["initAnalytics"]>;
};

export function createAlgoliaClients(config: ConfigWithoutAnalytics): {
	client: ReturnType<typeof algoliasearch>;
	searchClient: ReturnType<typeof liteClient>;
};

export function createAlgoliaClients({
	appId,
	apiKey,
	analyticsKey,
}: ConfigWithAnalytics | ConfigWithoutAnalytics) {
	const client = algoliasearch(appId, apiKey);
	const searchClient = liteClient(appId, apiKey);

	if (analyticsKey) {
		const analyticsClient = algoliasearch(appId, analyticsKey).initAnalytics({
			region: "de",
		});

		return { client, searchClient, analyticsClient };
	}

	return { client, searchClient };
}
